import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/e/employee-complete')({
  staticData: { hideShell: true },
});
